import { render, staticRenderFns } from "./WasteDiagnosticResumePage.vue?vue&type=template&id=2f025d86&scoped=true&"
import script from "./WasteDiagnosticResumePage.vue?vue&type=script&lang=js&"
export * from "./WasteDiagnosticResumePage.vue?vue&type=script&lang=js&"
import style0 from "./WasteDiagnosticResumePage.vue?vue&type=style&index=0&id=2f025d86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f025d86",
  null
  
)

export default component.exports